<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3>Add Block Time</h3>
      <button mat-icon-button (click)="CloseBlock(false)">
        <mat-icon class="close">close</mat-icon>
      </button>
    </div>

  </div>
  <div class="dialog_content">


    <div class="hold">
      <!-- <mat-form-field appearance="">
          <mat-label>Name </mat-label>
          <input matInput value="David Williams - Heart Surgery">
        </mat-form-field> -->


      <mat-form-field appearance="">
        <mat-label>Surgeon</mat-label>
        <mat-select>
          <mat-option value="1">M.Mcalpin</mat-option>
          <mat-option value="2">A.Jethro</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="">
        <mat-label>OR</mat-label>
        <mat-select>
          <mat-option value="1">F1</mat-option>
          <mat-option value="2">F2</mat-option>
        </mat-select>
      </mat-form-field>



      <mat-form-field class="">
        <mat-label>Procedure</mat-label>
        <mat-chip-list #chipList aria-label="Fruit selection">
          <mat-chip *ngFor="let fruit of fruits" [selectable]="selectable" [removable]="removable"
            (removed)="remove(fruit)">
            {{fruit}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip>
          <input placeholder="Type & Select Procedure..." #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
            [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
            {{fruit}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>



      <mat-form-field appearance="">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="">
        <mat-label>Start Time</mat-label>
        <input matInput>
      </mat-form-field>

      <mat-form-field appearance="">
        <mat-label>End Time</mat-label>
        <input matInput>
      </mat-form-field>

      <mat-form-field appearance="">
        <mat-label>Duration</mat-label>
        <input matInput>
      </mat-form-field>



      <mat-form-field appearance="">
        <mat-label>Description</mat-label>
        <textarea matInput placeholder="Add Duration..."></textarea>
      </mat-form-field>

      <mat-form-field appearance="">
        <mat-label>Notes</mat-label>
        <textarea matInput placeholder="Add Note..."></textarea>
      </mat-form-field>



      <div class="trepeat">
        <label>Repeat Block Time <mat-slide-toggle color="primary" [(ngModel)]="isRepeat" ></mat-slide-toggle></label>
        
        <ng-container *ngIf="isRepeat">
          <div class="specific" >

            <mat-form-field class="datefield">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="picker2">
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
  
            <div class="fieldr">
              <mat-form-field>
              <mat-label>Repeat every</mat-label>
              <mat-select value="" >
                <mat-option value="" >1</mat-option>
                <mat-option value="">2</mat-option>
                <mat-option value="">3</mat-option>
                <mat-option value="">4</mat-option>
              </mat-select>
            </mat-form-field> 
          </div>
  
            <div class="fieldr">
              <mat-form-field>
              <mat-label>Repeat</mat-label>
              <mat-select value="" >
                <mat-option value="" >day</mat-option>
                <mat-option value="">week</mat-option>
                <mat-option value="">month</mat-option>
                <mat-option value="">year</mat-option>
              </mat-select>
            </mat-form-field> 
          </div>
        
          </div>
  
          <div class="everyday">
  
            <label class="checkmark">
              <input type="checkbox" checked="checked">
              <span class="">M</span>
            </label>
            <label class="checkmark">
              <input type="checkbox" checked="checked">
              <span class="">T</span>
            </label>
            <label class="checkmark">
              <input type="checkbox" checked="checked">
              <span class="">W</span>
            </label>
            <label class="checkmark">
              <input type="checkbox" checked="checked">
              <span class="">T</span>
            </label>
  
            <label class="checkmark">
              <input type="checkbox" checked="checked">
              <span class="">F</span>
            </label>
            <label class="checkmark">
              <input type="checkbox" checked="checked">
              <span class="">S</span>
            </label>
            <label class="checkmark">
              <input type="checkbox" checked="checked">
              <span class="">S</span>
            </label>
  
          </div>
  
          <p class="occurs" >Occurs every ...</p>
        </ng-container>

      </div>



    </div>







  </div>


  <div class="actionBtn">
    <button mat-flat-button class="calltoaction" type="submit" color="basic"> Close </button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary">Add</button>
  </div>
</mat-card>


<div class="overlay" (click)="CloseBlock(false)"></div>